import React from 'react'
import ImageList from 'components/uploader_v2_app/views/thumbnails_collection/image_list'

export default class  RowItem extends React.Component {

  onChange = (e) => {
    this.props.updateItem(this.props.campaignElementId, { extraAmount: e.target.value })
  }

  itemAttrs = () => ({
    name:                  this.props.item.elementName,
    extraAmount:           this.props.item.extraAmount,
    orderedAmount:         this.props.item.orderedAmount,
    locationElementAmount: this.props.item.locationElementAmount
  })

  render () {
    const { name, locationElementAmount, orderedAmount, extraAmount } = this.itemAttrs()
    return (
      <tr>
        <td>{name}</td>
        <td className="thumbnails-collection">
          <ImageList images={this.props.item.images || []} controlMenu={false} />
        </td>
        <td>{locationElementAmount}</td>
        <td>{orderedAmount}</td>
        <td>
          <input type="number" onChange={this.onChange} value={extraAmount} />
        </td>
      </tr>
    )
  }
}
